import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT =
  '<p><em><strong>"Fun learning experience embracing curiosity"</strong></em></p>\n<p>The primitive years of learning are important for both students and parents. We provide a comfortable space for learning where the children feel welcomed. The Junior School Programme takes the student on a fun learning experience where the teachers help them embrace their curiosity.</p>\n<p>We work on helping the students feel comfortable in the new environment and get accustomed to change. We aim to help them grow academically and also socially. The foundation of the program is experience and curiosity. We assist the students to identify the \'Why\' and finding the answers to those \'Whys\'. St. Andrews World School programs combine science, language, social science, physical education, and music in experiential units. The curriculum is designed for the students to have a basic understanding of the concept and be able to independently derive the answers.</p>\n<p><em><strong>"All work and no play makes Jack a dull boy"</strong></em></p>\n<p>Physical education is equally prioritized at St. Andrews World School, Indirapuram. Our professional faculty helps the students to develop tactical skills through innovative exercises. The aim is to improve movement and balance.</p>\n<p>The faculty of art &amp; music work on developing the creative skills of the students. The children are introduced to art and aesthetics, which helps them express themselves creatively. This also builds an early appreciation of arts and music.</p>';

const JuniorSchoolProgrammePage = () => {
  const pageData = usePage('junior-school-programme', { content: DEFAULT_CONTENT });

  const title = 'Junior School Programme';

  return (
    <>
      <SEO title={title} description="Junior School Programme at St. Andrews World School, Indirapuram." keywords="Junior School Programme, SAWS Indirapuram" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/admission-guidliness.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default JuniorSchoolProgrammePage;
